import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { CompanyDirectoryService } from 'rainbow-web-sdk/services/company/company-directory.service';

export class BusinessDirectoryPlugin extends Plugin {
    public static initialize(): BusinessDirectoryPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[BusinessDirectoryPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[BusinessDirectoryPlugin] initialized");
            window.rainbow.plugins[BusinessDirectoryPlugin.name] = new BusinessDirectoryPlugin();
            CompanyDirectoryService.getInstance();
        }
        return window.rainbow.plugins[BusinessDirectoryPlugin.name];
    }

    private constructor() {
        super();
    }
}
